export default class ShowContent {
	constructor() {
		this.dataAttr = 'data-show-content',
		this.activeClass = 'active',

		this.initilize();
	}

	toggle() {
		const that = this;

		$(`[${this.dataAttr}]`).on('click', function (e) {
			e.preventDefault();

			const clicked = $(this);
			const data = clicked.attr(that.dataAttr);

			if (!clicked.hasClass(that.activeClass)) {
				clicked.addClass(that.activeClass);
				$(data).slideDown();
			} else {
				clicked.removeClass(that.activeClass);
				$(data).slideUp();
			}
		});
	}

	initilize() {
		this.toggle()
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/showContent.js